import { postRequest } from "../requests";

export interface ViewViewedEvent {
    ViewUrl: string;
    TabKey: string;
    ParticipantID: string;
    Platform?: "iOS" | "Web" | "Android";
}

export default function getViewViewedLogger() {
    let url = 'api/researchkit/analytics/trackViewViewed';

    return function (event: ViewViewedEvent) {
        return postRequest(url, event);
    }
}